import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

interface FeatureBoxProps {
  backgroundImg?: string;
  featureLink?: string;
  featureText?: string;
  featureSubText?: string;
}

export default function FeatureBox(props: FeatureBoxProps): ReactElement {
  const { backgroundImg, featureLink, featureText, featureSubText } = props;
  return (
    <Link
      className="FeatureBox"
      to={featureLink || '#'}
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className="FeatureBox-content-wrapper">
        <span className="bold">{featureText}</span>
        <span>{featureSubText}</span>
      </div>
    </Link>
  );
}
